import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BlockProductsCarousel from "../blocks/BlockProductsCarousel";
import { uaqFreeTradeZoneApi } from "../../api/uaqFreeTradeZone";
import "./uaqFreeTradeZone.css";

const tabs = [{ id: "freezone", name: "Freezone" }, { id: "freelance", name: "Freelance" }];
export default function UaqFreeTradeZoneHome() {
  const [tab, setTab] = useState("freezone");
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setFailed(false);
    Promise.all(tabs.map(item => uaqFreeTradeZoneApi.home(item.id, controller.signal))).then(results => {
      if (!controller.signal.aborted) setData(Object.fromEntries(tabs.map((item, index) => [item.id, results[index]])));
    }).catch(() => { if (!controller.signal.aborted) setFailed(true); });
    return () => controller.abort();
  }, [retry]);
  if (failed) return <section className="container uaq-free-trade-zone-home"><p role="status">Unable to load UAQ Free Trade Zone Packages. <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setRetry(value => value + 1)}>Retry</button></p></section>;
  if (!data || !data[tab].visible || !tabs.some(item => data[item.id].products.length)) return null;
  const selected = data[tab];
  return <section className="uaq-free-trade-zone-home" aria-label={selected.title}>
    <BlockProductsCarousel key={tab} title={selected.title} subtitle={selected.subtitle} layout="grid-4" tour={false}
      products={selected.products} groups={tabs.map(item => ({ ...item, current: item.id === tab }))} onGroupClick={item => setTab(item.id)} />
    {!selected.products.length && <p className="container" role="status">No {tab === "freezone" ? "Freezone" : "Freelance"} packages selected yet.</p>}
    <div className="container uaq-free-trade-zone-home__more"><Link className="btn btn-primary" to={`/uaq-free-trade-zone-packages?tab=${tab}`}>View More <span aria-hidden="true">→</span></Link></div>
  </section>;
}
